<template>
  <div id="vip">
    <van-row class="vip_shop">
      <van-col span="22" offset="1">
        <van-col span="24">
          <van-col span="12" class="grade_type grade_chencked">{{ $t('column.agent_title') }}</van-col>
          <van-col span="12" class="grade_type"  @click="vip_href()">{{ $t('column.vip_title') }}</van-col>
          <van-col span="2" offset="5" class="grade_chencked_vip"></van-col>
        </van-col>
        <van-col span="24" class="agent_grade_bg">
          <div class="vip_grade_img">
            <van-image round width="4.5em" height="4.5em" :src="user.head_image" />
          </div>
            <van-col span="24" class="agent_grade_title">{{ user.nick_name }}</van-col>
            <van-col span="22" offset="1">
              <van-steps :active="active" active-color="#A659FF">
                <van-step  v-for="(l,i) in list" :key="i" :class="i % 2 === 0 ? 'agent_bottom' : ''" @click.native="active_btn( i )">
                  <van-col :class="i === 0 ? 'agent_titles agent_titles_left' : 'agent_titles'">{{ l.name }}</van-col>
                </van-step>
              </van-steps>
            </van-col>
        </van-col>
        <van-col span="24" class="agent_grade" v-if="list[active_type] && list[active_type].id > 2 && user.marketing_id < list[active_type].id">
          <van-col span="19">
            <van-col span="24" class="agent_grade_title_level">邀请{{ list[active_type - 1].upgrade_sum }}个{{ list[active_type - 1].name }}直接升级为{{ list[active_type].name }}</van-col>
            <van-col span="18" class="agent_grade_title_sum">
              <van-progress :percentage="10" pivot-text="" color="#9E64FF" track-color="#e6e6e6"/>
            </van-col>
            <van-col span="6" class="agent_grade_progress_sum">{{ list[active_type].marketing_sum }}/{{ list[active_type - 1].upgrade_sum }}</van-col>
          </van-col>
          <van-col span="5">
            <van-button class="agent_grade_btn" @click="invitation_share_btn">立即邀请</van-button>
          </van-col>
        </van-col>
      </van-col>
      <van-col span="24" class="agent_grade_border"></van-col>
      <van-col span="22" offset="1">

          <van-col span="24" class="agent_grade_privilege_title">{{ active_type | get_active_type(that) }}权益奖励</van-col>
          <van-col span="24" class="agent_grade_type">
            <van-tabs v-model="active_type">
              <van-tab v-for="(v,k) in list"  :key="k"  :title="v.name" class="agent_grade_type_list" >
                <van-col span="24" class="agent_grade_type_border">
                  <van-col span="24" class="agent_grade_type_one">
                     <van-col span="12" class="agent_grade_type_one_name">主播带货收益</van-col>
                    <van-col span="12" class="agent_grade_type_one_sum">{{ v.profit_room_goods ? v.profit_room_goods *100 : 0}}%</van-col>
                  </van-col>
                  <van-col span="24" class="agent_grade_type_one">
                    <van-col span="12" class="agent_grade_type_one_name">直播间购物收益</van-col>
                    <van-col span="12" class="agent_grade_type_one_sum">{{ v.consumption_room_goods ? v.consumption_room_goods * 100 : 0}}%</van-col>
                  </van-col>
                  <van-col span="24" class="agent_grade_type_one">
                    <van-col span="12" class="agent_grade_type_one_name">直播间打赏主播收益</van-col>
                    <van-col span="12" class="agent_grade_type_one_sum">{{ v.profit_room_reward ? v.profit_room_reward *100 : 0}}%</van-col>
                  </van-col>
                  <van-col span="24" class="agent_grade_type_one">
                    <van-col span="12" class="agent_grade_type_one_name">直播间会员打赏收益</van-col>
                    <van-col span="12" class="agent_grade_type_one_sum">{{ v.consumption_room_reward ? v.consumption_room_reward *100 : 0}}%</van-col>
                  </van-col>

                  <van-col span="24" class="agent_grade_type_one">
                    <van-col span="12" class="agent_grade_type_one_name">短视频带货收益</van-col>
                    <van-col span="12" class="agent_grade_type_one_sum">{{ v.profit_video_goods ? v.profit_video_goods * 100 : 0}}%</van-col>
                  </van-col>
                  <van-col span="24" class="agent_grade_type_one">
                    <van-col span="12" class="agent_grade_type_one_name">短视频购物收益</van-col>
                    <van-col span="12" class="agent_grade_type_one_sum">{{ v.consumption_video_goods ? v.consumption_video_goods * 100 : 0}}%</van-col>
                  </van-col>
                  <van-col span="24" class="agent_grade_type_one">
                    <van-col span="12" class="agent_grade_type_one_name">短视频打赏主播收益</van-col>
                    <van-col span="12" class="agent_grade_type_one_sum">{{ v.profit_video_reward ? v.profit_video_reward * 100 : 0}}%</van-col>
                  </van-col>
                  <van-col span="24" class="agent_grade_type_one">
                    <van-col span="12" class="agent_grade_type_one_name">短视频会员打赏收益</van-col>
                    <van-col span="12" class="agent_grade_type_one_sum">{{ v.consumption_video_reward ? v.consumption_video_reward * 100 : 0}}%</van-col>
                  </van-col>
                  <van-col span="24" class="agent_grade_type_one">
                    <van-col span="12" class="agent_grade_type_one_name">商城店铺收益</van-col>
                    <van-col span="12" class="agent_grade_type_one_sum">{{ v.profit_shop ? v.profit_shop * 100 : 0}}%</van-col>
                  </van-col>
                  <van-col span="24" class="agent_grade_type_one">
                    <van-col span="12" class="agent_grade_type_one_name">购买商城商品收益</van-col>
                    <van-col span="12" class="agent_grade_type_one_sum">{{ v.consumption_shop ? v.consumption_shop * 100 : 0}}%</van-col>
                  </van-col>
                  <van-col span="24" class="agent_grade_type_one">
                    <van-col span="12" class="agent_grade_type_one_name">鑫值提现手续费</van-col>
                    <van-col span="12" class="agent_grade_type_one_sum">{{ v.withdrawal ? v.withdrawal *100 : 0}}%</van-col>
                  </van-col>
                </van-col>
                <van-col span="20" offset="2" v-if="v.id !=1 && user.marketing_id <= v.id">
                  <van-col span="24" v-if="v.id  < 5  && v.attr_id > 0 && user.marketing_id < v.id">
                    <van-button class="agent_btn" @click="shop_pay">立即购买</van-button>
                  </van-col>
                  <van-col span="24" v-else-if="v.id == 5">
                    <van-button class="agent_btn agent_not_reached" v-if="v.marketing_sum < v.upgrade_sum && v.is_apply === '-1'">申请地区区域</van-button>
                    <van-button class="agent_btn" v-else-if="v.is_apply === '-1'" @click="apply_btn(1)">申请地区区域</van-button>
                    <van-button class="agent_btn agent_not_reached" v-else-if="v.is_apply === '0'">代理区域-已申请</van-button>
                    <van-button class="agent_btn agent_not_reached" v-else-if="v.is_apply === '1'">代理区域已通过-{{ v.is_apply_name }}</van-button>
                    <van-button class="agent_btn" v-else-if="v.is_apply === '2'" @click="apply_btn(1)">代理区域已拒绝-重新申请</van-button>
                  </van-col>
                  <van-col span="24" v-else-if="v.id == 6">
                    <van-button class="agent_btn agent_not_reached" v-if="v.marketing_sum < v.upgrade_sum && v.is_apply === '-1'">申请代理省份</van-button>
                    <van-button class="agent_btn" v-else-if="v.is_apply === '-1'" @click="apply_btn(0)">申请代理省份</van-button>
                    <van-button class="agent_btn agent_not_reached" v-else-if="v.is_apply === '0'">代理省份-已申请</van-button>
                    <van-button class="agent_btn agent_not_reached" v-else-if="v.is_apply === '1'">代理省份已通过-{{ v.is_apply_name }}</van-button>
                    <van-button class="agent_btn" v-else-if="v.is_apply === '2'" @click="apply_btn(0)">代理省份已拒绝-重新申请</van-button>
                  </van-col>
                </van-col>
              </van-tab>
            </van-tabs>
          </van-col>
        <van-col span="24" class="agent_grade_bottom"></van-col>
        <van-dialog v-model="showRegion" :title="cityType === 1 ? '选择代理区域' :'选择代理省份'" show-cancel-button  @confirm="CityConfirm"
                    @cancel="CityCancel">
          <van-cell title="地址" is-link  :value="province | getCity(city,that)" class="agent_show_region" @click="showCityBtn"/>
        </van-dialog>
        <van-popup v-model="showCity" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="onCancel"
          />
        </van-popup>
      </van-col>

    </van-row>
  </div>
</template>

<script>

  import '@/assets/css/style.css'
  import { judgeIosAndroid } from '@/assets/js/models.js'
  import axios from 'axios'
  import Toast from "vant/lib/toast"
  import { Dialog, Progress, Step, Steps, Picker, Cell, Popup } from 'vant'
  export default {
    filters: {
      get_active_type(active_type, that) {
       return that.list[active_type] ? that.list[active_type].name : ''
      },
      getCity(province, city, that) {
        if(that.cityType) {
          if (that.columns[province]) {
            return that.columns[city] ? that.columns[province].text + ' - ' + that.columns[province].children[city].text : ''
          } else {
            return ''
          }
        } else {
          return that.columns[province] ? that.columns[province].text : ''
        }
      }
    },
    data() {
      return {
        province: '',
        city: '',
        regionType: [],
        cityType: 0,
        showCity: false,
        showRegion: false,
        that: this,
        active_type: 0,
        active: 0,
        list:[],
        columns: [],
        user:{}
      }
    },
    created: function() {
      this.convert();
      document.title = this.$t('title.agent')
    },
    mounted() {
      // 将要给原生调用的方法挂载到 window 上面
      window.mobile_intercept = this.mobile_intercept
    },
    components: {
      [Dialog.name]: Dialog,
      [Progress.name]: Progress,
      [Picker.name]: Picker,
      [Cell.name]: Cell,
      [Popup.name]: Popup,
      [Step.name]: Step,
      [Steps.name]: Steps
    },
    methods: {
      CityConfirm() {
        // 提交地区申请
       const province = this.columns[this.province] ? this.columns[this.province].id : ''
        if (!province) {
          Toast('请选择地区')
          return false
        }
        const city = this.columns[this.province].children[this.city] ? this.columns[this.province].children[this.city].id : ''
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=agent&act=apply", {
          params : {
            token: token,
            cityType: this.cityType,
            province: province,
            city: city
          }
        }).then(res =>{
          console.log(res.data)
          Toast(res.data.error)
          if (res.data.status === 1) {
            this.convert()
          }
          this.showCity = false
        })

      },
      apply_btn(i) {
        this.cityType = i
        this.showRegion = true
      },
      CityCancel() {
        this.showCity = false
      },
      onConfirm(value, index) {
        console.log(value)
        console.log(index)
        if(this.cityType) {
          this.province =index[0]
          this.city = index[1]
        } else {
          this.province =index
        }
        this.showCity = false
      },
      onCancel() {
        this.showCity = false
      },
      showCityBtn() {
        if(this.cityType) {
          // 有城市
          this.columns = this.regionType
        } else {
          // 只有省
          this.columns = []
          for(let i=0; i < this.regionType.length; i++) {
            const list = { 'id' : this.regionType[i].id, 'text': this.regionType[i].text}
            this.columns.push(list)
          }
        }
        this.showCity = true
      },
      active_btn(i) {
        this.active_type = i
      },
      convert: function() {
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=agent&act=index", {
          params : {
            token: token
          }
        }).then(res =>{
          console.log(res.data)
          this.list = res.data.data.marketing_list
          this.active = res.data.data.user.active
          this.active_type = res.data.data.user.active
          this.regionType = res.data.data.region_list
          if (res.data.status === 0) {
            Toast(res.data.error)
            return false
          }else{
            this.user = res.data.data.user
          }
        })
      },
      invitation_share_btn () {
        // 分享拦截
        this.mobile_intercept(this.url)
      },
      mobile_intercept(url) {
        //  拦截
        const isIos = judgeIosAndroid();
        if (isIos == true) {
          // ios传值方法postMessage（val）传值方式
          window.webkit.messageHandlers.distribution_share.postMessage(url)
        } else {
          // ios传值方法goSubmitted（val）传值方式
          window.AndroidJs.distribution_share(url)
        }
      },
      shop_pay() {
        // 立即购买
        this.shop_pay_href();
      },
      shop_pay_href() {
        //  拦截
        const isIos = judgeIosAndroid();
        if (isIos == true) {
          // ios传值方法postMessage（val）传值方式
          window.webkit.messageHandlers.shop_pay_href.postMessage('')
        } else {
          // Android传值方法goSubmitted（val）传值方式
          window.AndroidJs.shop_pay_href('')
        }
      },
      vip_href() {
        const token = this.$route.query.token
        this.$router.push({path: '/vip_grade', query: {token: token}});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/agent.vue